/**
 * SchemaAttributeName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectSchemaAttributeValue } from '../../services/schemaAttributes/selectors';

interface Props {
    name?: string;
}

export class SchemaAttributeName extends React.PureComponent<Props> {
    render() {
        return this.props.name || null;
    }
}

const mapStateToProps = createStructuredSelector({
    name: makeSelectSchemaAttributeValue('name')
});

export default connect(mapStateToProps)(SchemaAttributeName);
